// Generate Acknowledgement PDF
export const ACKNOWLEDGEMENT_GENERATE_REQUEST = 'ACKNOWLEDGEMENT_GENERATE_REQUEST'
export const ACKNOWLEDGEMENT_GENERATE_SUCCESS = 'ACKNOWLEDGEMENT_GENERATE_SUCCESS'
export const ACKNOWLEDGEMENT_GENERATE_FAIL = 'ACKNOWLEDGEMENT_GENERATE_FAIL'

// Preview Acknowledgement (HTML)
export const ACKNOWLEDGEMENT_PREVIEW_REQUEST = 'ACKNOWLEDGEMENT_PREVIEW_REQUEST'
export const ACKNOWLEDGEMENT_PREVIEW_SUCCESS = 'ACKNOWLEDGEMENT_PREVIEW_SUCCESS'
export const ACKNOWLEDGEMENT_PREVIEW_FAIL = 'ACKNOWLEDGEMENT_PREVIEW_FAIL'

// Download Acknowledgement PDF
export const ACKNOWLEDGEMENT_DOWNLOAD_REQUEST = 'ACKNOWLEDGEMENT_DOWNLOAD_REQUEST'
export const ACKNOWLEDGEMENT_DOWNLOAD_SUCCESS = 'ACKNOWLEDGEMENT_DOWNLOAD_SUCCESS'
export const ACKNOWLEDGEMENT_DOWNLOAD_FAIL = 'ACKNOWLEDGEMENT_DOWNLOAD_FAIL'

// Copy Acknowledgement PDF
export const ACKNOWLEDGEMENT_COPY_REQUEST = 'ACKNOWLEDGEMENT_COPY_REQUEST'
export const ACKNOWLEDGEMENT_COPY_SUCCESS = 'ACKNOWLEDGEMENT_COPY_SUCCESS'
export const ACKNOWLEDGEMENT_COPY_FAIL = 'ACKNOWLEDGEMENT_COPY_FAIL'

// Email Acknowledgement PDF
export const ACKNOWLEDGEMENT_EMAIL_REQUEST = 'ACKNOWLEDGEMENT_EMAIL_REQUEST'
export const ACKNOWLEDGEMENT_EMAIL_SUCCESS = 'ACKNOWLEDGEMENT_EMAIL_SUCCESS'
export const ACKNOWLEDGEMENT_EMAIL_FAIL = 'ACKNOWLEDGEMENT_EMAIL_FAIL'

//Erp Acknowledgement
export const ACKNOWLEDGEMENT_ERP_PRINT_REQUEST = 'ACKNOWLEDGEMENT_ERP_PRINT_REQUEST'
export const ACKNOWLEDGEMENT_ERP_PRINT_SUCCESS = 'ACKNOWLEDGEMENT_ERP_PRINT_SUCCESS'
export const ACKNOWLEDGEMENT_ERP_PRINT_FAIL = 'ACKNOWLEDGEMENT_ERP_PRINT_FAIL'

// Reset state
export const ACKNOWLEDGEMENT_RESET = 'ACKNOWLEDGEMENT_RESET'
